<template>
    <div class="container" :style="{ 'padding-bottom': showBottom ? '3.75rem' : '0' }">
        <div @click="openLY">
            <img :src="`http://cdntiku.oss-cn-shanghai.aliyuncs.com/h5/mq_toeflwrite/1.png?v=1`" alt />
            <img :src="`http://cdntiku.oss-cn-shanghai.aliyuncs.com/h5/mq_toeflwrite/2.png?v=1`" alt />
            <img :src="`http://cdntiku.oss-cn-shanghai.aliyuncs.com/h5/mq_toeflwrite/3.png?v=1`" alt />
            <img :src="`http://cdntiku.oss-cn-shanghai.aliyuncs.com/h5/mq_toeflwrite/4.png?v=1`" alt />
            <img :src="`http://cdntiku.oss-cn-shanghai.aliyuncs.com/h5/mq_toeflwrite/5.png?v=1`" alt />
            <img :src="`http://cdntiku.oss-cn-shanghai.aliyuncs.com/h5/mq_toeflwrite/6.png?v=1`" alt />
        </div>
        <moveAndTips ref="moveAndTips" :pageSource="pageSource" :needTips="true"></moveAndTips>
        <footer v-if="showBottom">
            <button class="orange-btn" @click="openLY">咨询课程价格</button>
            <!-- <button v-if="ppid0" class="orange-btn" @click="gotoWechat">咨询课程价格</button> -->
        </footer>
    </div>
</template>

<script>
import { ref, onMounted, inject, getCurrentInstance } from "vue";
import moveAndTips from "@/components/moveAndTips";
import wk from "../../utils/jsBridge.js";
import utils from "../../utils/utils.js";
import { Toast } from "vant";

export default {
    components: { moveAndTips },
    setup() {
        const showBottom = ref(true);
        // const ppid0 = ref(false);
        // const ppid1 = ref(false);
        const isAction = ref(false);
        const showDestroyDialog = ref(false); //记录是否显示过退出弹窗
        const moveAndTips = ref();
        const ppid = ref("");
        // const isNewClient = ref(false);
        const isLoading = ref(false);
        const pageSource = ref();
        const mapId = ref("");
        const sid = ref("toeflpractice");
        const sensors = inject("$sensors");
        const { proxy } = getCurrentInstance();
        if (window.location.href.indexOf("v=1.2.0") > -1) {
            showBottom.value = true;
        }
        document.title = '托福备考';
        //打开乐语对话
        const openLY = () => {
            if (utils.userIdIsEmpty(ppid.value)) {
                Toast("请先登录");
                return;
            }
            sensors.track("page_source_click", {
                page_source: 10128,
                map_id: 30105
            });
            // if (ppid.value) { noCourseConsultationAdd({ userId: ppid.value, url: window.location.href }); }
            isAction.value = true;
            moveAndTips.value.checkAction();
            console.log(JSON.stringify({
                ppid: ppid.value,
                sid: sid.value
            }));
            _MEIQIA("showPanel"); // eslint-disable-line
        };
        //跳转微信小程序
        const gotoWechat = () => {
            if (isLoading.value) return;
            sensors.track("page_source_click", {
                page_source: 10128,
                map_id: 30204
            });
            isLoading.value = true;
            wk.openWxNew(ppid.value, 2
                , () => {
                    isLoading.value = false;
                })
            // wk.callHandler(
            //     "JumpToMiniProgramDynamic", {
            //     username: 'gh_a5f73db7e592',
            //     path: `/pages/kezinew/kezinew?userId=${ppid.value}`
            // });
        };
        sensors.track("course_detail_page", {
            course_id: 10128,
            course_name: "speaking&writing"
        });
        onMounted(() => {
            pageSource.value = 10128;
            mapId.value = 30095;

            sensors.track("page_view", {
                page_source: pageSource.value
            });

            wk.init(() => {
                console.log("wk init");
                //托福雅思判断切换
                let sub_soure = "sub_source_46";
                let query = proxy.$router.currentRoute.value.query;
                ppid.value = wk.getPpId() || query.pp_id || query.ppid || "";
                console.log("ppid:" + ppid.value);

                utils.initMeiQia();
                if (ppid.value) {
                    _MEIQIA("clientId", ppid.value); // eslint-disable-line
                }
                _MEIQIA("metadata", {// eslint-disable-line
                    渠道手机号识别: `pp_id=${ppid.value}&sid=${sid.value}`
                });
                _MEIQIA("entId", "769889ab4e5d95d1a817987ec60c7040"); // eslint-disable-line
                _MEIQIA("withoutBtn"); // eslint-disable-line
                _MEIQIA("subSource", sub_soure); // eslint-disable-line
                // }
            });
        });
        return {
            showBottom,
            isAction,
            showDestroyDialog,
            pageSource,
            mapId,
            sid,
            openLY,
            moveAndTips,
            // ppid0,
            // ppid1,
            gotoWechat
        };
    }
};
</script>

<style scoped>
img {
    display: block;
}

footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 99;
    width: 100%;
    padding: 0.5rem 0;
    background: #fff;
}

.orange-btn {
    display: block;
    width: 90%;
    height: 2.75rem;
    font-size: 1rem;
    color: #fff;
    font-weight: bold;
    text-align: center;
    border: none;
    outline: none;
    border-radius: 1.38rem;
    background: linear-gradient(135deg, #ff913f 0%, #ff652d 100%);
    margin: 0 auto;
    position: relative;
}

.wechat::before {
    content: ' ';
    position: absolute;
    background: url(https://cdntiku.oss-cn-shanghai.aliyuncs.com/h5/wechat.png) no-repeat;
    background-size: 100%;
    width: 1.25rem;
    height: 1.25rem;
    top: 50%;
    margin-left: -1.5rem;
    transform: translateY(-50%);
}
</style>